var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export function HowToRegFill(_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M15.625 20.4L12.1 16.875L13.15 15.825L15.625 18.3L20.95 12.975L22 14.025L15.625 20.4ZM10 11.95C8.9 11.95 8 11.6 7.3 10.9C6.6 10.2 6.25 9.3 6.25 8.2C6.25 7.1 6.6 6.2 7.3 5.5C8 4.8 8.9 4.45 10 4.45C11.1 4.45 12 4.8 12.7 5.5C13.4 6.2 13.75 7.1 13.75 8.2C13.75 9.3 13.4 10.2 12.7 10.9C12 11.6 11.1 11.95 10 11.95ZM13.2 13.9L10.1 17.125L12.975 20H2V17.65C2 17.0833 2.14167 16.5625 2.425 16.0875C2.70833 15.6125 3.13333 15.25 3.7 15C4.9 14.4667 6 14.0833 7 13.85C8 13.6167 9 13.5 10 13.5C10.4833 13.5 10.9958 13.5292 11.5375 13.5875C12.0792 13.6458 12.6333 13.75 13.2 13.9Z", fill: color }) })));
}
